import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';
import type { RouteObject } from 'react-router-dom';
import StorageModuleGate from './components/StorageModuleGate';

const StorageListPage = Loadable(lazy(() => import('./components/StorageListPage')));
const StorageQuotesPage = Loadable(lazy(() => import('./components/StorageQuotesPage')));
const StorageManagePage = Loadable(lazy(() => import('./components/StorageManagePage')));
const StorageParallelPaymentPage = Loadable(lazy(() => import('./components/StorageParallelPaymentPage')));
const StoragePaymentReturnPage = Loadable(lazy(() => import('./components/StoragePaymentReturnPage')));

/**
 * This feature's own routes, composed into the app router the same way every other feature's
 * routes.tsx is (see features/quotes/routes.tsx, features/shipments/routes.tsx) — spread into
 * src/app/routes/AuthenticatedRoutes.tsx by hand.
 *
 * Four entries, each built by a different parallel agent against this same file and merged in
 * by hand afterward (integration pass, not a guess): the `/storage` list page, the
 * `/storage/:requestId/quotes` "ver cotizaciones y pagar" screen (this file's original author),
 * `/storage/:requestId/manage` for an already-resolved (accepted) request, and
 * `/storage/parallel/:shipmentId/:storageRequestId` — the combined payment screen for a
 * mudanza published together with a storage request via the wizard's Guardado toggle.
 * NEX-1167 added a fifth, `/storage/payment/return`, Mercado Pago's return page.
 *
 * NEX-1645 (plan 2026-10-20, Tarea 3.3) — each page sits behind StorageModuleGate (the storage module's
 * state: with `off` every one of them goes to Inicio). Wrapped one by one instead of under a pathless
 * layout route, so each entry keeps its own literal `path` (e2e/lib/enumerate-routes.js reads them).
 */
export const storageRoutes: RouteObject[] = [
  {
    path: '/storage',
    element: (
      <StorageModuleGate>
        <StorageListPage />
      </StorageModuleGate>
    )
  },
  {
    path: '/storage/parallel/:shipmentId/:storageRequestId',
    element: (
      <StorageModuleGate>
        <StorageParallelPaymentPage />
      </StorageModuleGate>
    )
  },
  // NEX-1167 — Mercado Pago's single return URL for every storage payment (nexvia-api-web's
  // `storagePaymentReturnUrl`). A static segment, so it never matches `/storage/:requestId/...`.
  {
    path: '/storage/payment/return',
    element: (
      <StorageModuleGate>
        <StoragePaymentReturnPage />
      </StorageModuleGate>
    )
  },
  {
    path: '/storage/:requestId/quotes',
    element: (
      <StorageModuleGate>
        <StorageQuotesPage />
      </StorageModuleGate>
    )
  },
  {
    path: '/storage/:requestId/manage',
    element: (
      <StorageModuleGate>
        <StorageManagePage />
      </StorageModuleGate>
    )
  }
];
